// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-2a6","label":"styles_label__J2C2q"};